<div
  class="ui label warning-label"
  style="
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
  "
  *ngIf="message"
>
  <div>{{ message }}</div>
  <button
    *ngIf="redirect_url"
    style="margin-top: 15px"
    class="ui primary button"
  >
    <a href="{{ redirect_url }}" style="color: white">
      Go back to {{ applicationType }} application
    </a>
  </button>
</div>
<div class="heading" fxLayout="row" fxLayoutAlign="space-between center">
  <h3 appMargin marginB="0" class="ui primary header">
    {{
      companyTypeName === "business_name_actual" ||
      companyTypeName === "business_name"
        ? "Owners Of Business"
        : "Directors"
    }}
  </h3>
  <div>
    <label
      *ngIf="(!isEdit && directorStatus) || (isPending && directorStatus)"
      class="ui tiny circular label"
      [ngClass]="{
        'label-green': directorStatus == 'VERIFIED',
        'label-grey': directorStatus == 'NOT_AVAILABLE',
        'label-red': directorStatus == 'REJECTED',
        'label-orange':
          directorStatus == 'UNVERIFIED' || directorStatus == 'PENDING'
      }"
      >{{
        directorStatus == "NOT_AVAILABLE"
          ? ""
          : (directorStatus | removeUnderscore | uppercase)
      }}</label
    >
    <ng-container *ngIf="!isEdit && !isPending">
      <button
        *isPermitted="{ id: 'SHAREHOLDERS_MANAGEMENT', action: 'read' }"
        (click)="viewHistory()"
        class="ui tiny basic primary button"
      >
        View History
      </button>
      <button
        *isPermitted="{ id: 'SHAREHOLDERS_MANAGEMENT', action: 'read' }"
        (click)="updateDirector()"
        class="ui tiny primary button"
      >
        Make Updates
      </button></ng-container
    >

    <ng-container *ngIf="isEdit">
      <button
        *isPermitted="{ id: 'SHAREHOLDERS_MANAGEMENT', action: 'read' }"
        (click)="addDirector()"
        class="ui tiny basic primary button"
      >
        Add New Director
      </button>
      <button
        *isPermitted="{ id: 'SHAREHOLDERS_MANAGEMENT', action: 'read' }"
        (click)="saveDirector()"
        class="ui tiny primary button"
      >
        Save
      </button>
    </ng-container>
    <ng-container *ngIf="!isEdit && isPending">
      <button
        *isPermitted="{ id: 'SHAREHOLDERS_MANAGEMENT', action: 'read' }"
        (click)="viewHistory()"
        class="ui tiny basic primary button"
      >
        View Pending Updates
      </button>
      <button
        *isPermitted="{ id: 'SHAREHOLDERS_MANAGEMENT', action: 'read' }"
        (click)="updateDirector()"
        class="ui tiny primary button"
      >
        Make Updates
      </button>
    </ng-container>
  </div>
</div>
<hr />
<div class="ui label warning-label" *ngIf="directorStatus == 'PENDING'">
  Your changes are pending and will be verified in due time. However, you can
  send us a chat message
  <a style="font-weight: 900; color: #3f4395" [routerLink]="chatLink">here</a>
  if you have any question or feedback.
</div>

<div
  class="ui label warning-label label-green"
  *ngIf="directorStatus == 'VERIFIED'"
>
  Your Directors’ structure information has been verified.
</div>
<app-search-filter
  [filter]="filter"
  (onSearch)="searchRecords($event)"
  (onDisplayRows)="displayRecords($event)"
  (onSort)="sortRecords($event)"
></app-search-filter>

<div class="ui vertical basic segment" *ngIf="success || error">
  <esl-message-toast [(message)]="error"></esl-message-toast>
  <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
</div>
<!-- </div> -->

<div
  fxLayout="row"
  appMargin
  class="ui segment"
  marginB="3"
  fxLayoutGap="10px"
  fxLayoutAlign="start stretch"
  id="dark"
>
  <div fxFlex="5%" *ngIf="isEdit">
    <sui-checkbox> </sui-checkbox>
  </div>
  <div fxFlex="15%">FIRST NAME</div>
  <div fxFlex="15%">LAST NAME</div>
  <div fxFlex="15%">DATE ADDED</div>
  <div fxFlex="15%">ADDED BY</div>
  <div fxFlex="25%"></div>
</div>
<div
  class="ui vertical basic segment"
  [ngClass]="{ loading: pending }"
  appMargin="0"
  appPadding="0"
>
  <div
    class="ui segment"
    *ngFor="let director of companyDirectors"
    appMargin
    marginB="3"
    fxLayout="row"
    fxLayoutGap="10px"
    fxLayoutAlign="start stretch"
  >
    <div fxFlex="5%" *ngIf="isEdit">
      <sui-checkbox> </sui-checkbox>
    </div>
    <div fxFlex="15%">{{ director?.firstName }}</div>
    <div fxFlex="15%">{{ director?.lastName }}</div>
    <div fxFlex="15%">{{ director?.dateCreated | date }}</div>
    <div fxFlex="15%">{{ director?.createdBy | createdBy }}</div>
    <div fxFlex="20%"></div>
    <div fxFlex="20%" class="text-right">
      <ng-container *ngIf="isEdit">
        <button
          *isPermitted="{ id: 'SHAREHOLDERS_MANAGEMENT', action: 'remove' }"
          class="ui circular tiny button"
          suiPopup
          [popupInverted]="true"
          popupPlacement="bottom"
          popupText="Delete"
          (click)="deleteItem(director)"
        >
          <i class="trash icon"></i>
        </button>
        <button
          *isPermitted="{ id: 'SHAREHOLDERS_MANAGEMENT', action: 'edit' }"
          class="ui circular tiny button"
          suiPopup
          [popupInverted]="true"
          popupPlacement="bottom"
          popupText="Edit"
          (click)="edit(director)"
        >
          <i class="pencil icon"></i></button
      ></ng-container>
      <ng-container *ngIf="(!isEdit && !isPending) || isPending">
        <button
          *isPermitted="{ id: 'SHAREHOLDERS_MANAGEMENT', action: 'read' }"
          class="ui circular tiny button"
          suiPopup
          [popupInverted]="true"
          popupPlacement="bottom"
          popupText="View"
          (click)="directorRecord(director)"
        >
          <i class="eye icon"></i></button
      ></ng-container>
    </div>
  </div>
  <app-no-record-found
    *ngIf="companyDirectors && companyDirectors.length < 1"
  ></app-no-record-found>
</div>

<div class="ui vertical basic segment">
  <div class="ui two column grid">
    <div class="column middle aligned">
      <div class="ui labeled button">
        <div class="ui tiny icon button" (click)="getPage(1)">
          <i class="refresh icon"></i>
        </div>
        <a class="ui basic label"> {{ totalItems }} Record(s) </a>
      </div>
    </div>
    <div class="column right aligned pagination menu" style="margin-left: auto">
      <sui-pagination
        class="mini"
        [collectionSize]="totalItems"
        [pageSize]="rows"
        [maxSize]="maxSize"
        [hasEllipses]="false"
        [page]="currentPage"
        (pageChange)="nextPage($event)"
      >
      </sui-pagination>
    </div>
  </div>
</div>
